/** PURE_IMPORTS_START _AjaxObservable PURE_IMPORTS_END */
import { AjaxObservable } from './AjaxObservable';
export var ajax = /*@__PURE__*/ (function () { return AjaxObservable.create; })();
//# sourceMappingURL=ajax.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/observable/dom/ajax.js
// module id = 654
// module chunks = 0